module.exports = __webpack_public_path__ + "static/media/banner-asset-1.09e46342.png";